export interface AutorizacionOperacion {
  Id_Autorizacion: number;
  Id_Usuario: number;
  Usuario: string;
  Fecha: string; // ISO string, use Date if you prefer: Date;
  Id_Operacion: number;
  Operacion: OperacionesAutorizables; // You need to define this enum/type elsewhere
  Fecha_Caducidad: string; // ISO string, use Date if you prefer: Date;
  Ejecuciones_Permitidas: number;
  Ejecuciones_Realizadas: number;
  Autorizada: boolean;
}

// Example enum, adjust as needed
export enum OperacionesAutorizables {
  Descuento = 1,
  BajarPrecio = 2,
  QuitarLineaPV = 3,
  HacerNC = 4,
  ExcesoLimiteCuentaCorriente = 5,
}

// Friendly descriptions for each enum value
export const OperacionesAutorizablesDescriptions: Record<OperacionesAutorizables, string> = {
  [OperacionesAutorizables.Descuento]: "Aplicar un descuento",
  [OperacionesAutorizables.BajarPrecio]: "Reducir el precio",
  [OperacionesAutorizables.QuitarLineaPV]: "Eliminar una línea del punto de venta",
  [OperacionesAutorizables.HacerNC]: "Generar una nota de crédito",
  [OperacionesAutorizables.ExcesoLimiteCuentaCorriente]: "Superar límites de cuenta corriente",
};
